import { Stack } from '@mui/material';
import MediaPriceInfo from './media-price-info';
import { useMediaPrices } from 'entities/media/media-price';

type Props = {
    mediaId: number;
};

const MediaSuppliersArchivePrices = (props: Props) => {
  const { mediaId } = props;
  const { items } = useMediaPrices({ mediaId, options: { isActive: false } });
  const prices = items;

  return (
    <>
      {prices && (
        <Stack direction='column' spacing={1}>
          {prices.map((x, i) => (
            <MediaPriceInfo
              key={i}
              priceInfo={x}
            />
          ))}
        </Stack>
      )}
    </>
  );
};

export default MediaSuppliersArchivePrices;
